import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import "../styles/Product.css"
import product2 from "../assets/images/groundnutpng3.png";
import product3 from "../assets/images/sesameposterpng2.png";
import product4 from "../assets/images/mustardposterpng.png";
import product5 from "../assets/images/deepamposterpng.png";
import product6 from "../assets/images/castoroilposter1.png";
import chips2 from "../assets/images/chocolate.png";
import chips3 from "../assets/images/chocolate_original_2_11zon.webp";
import chips4 from "../assets/images/cholate_vanila_4_11zon.webp";
import rose from "../assets/images/chocolate_Rose_3_11zon.png";
import chips5 from "../assets/images/chocolate_ll_three_package_1_11zon.png";
import ghee1 from "../assets/images/ghee_Jagger.webp";
import juggery from "../assets/images/jaggeryposterpng.png"
import butterunsweet from "../assets/images/PEANUT BUTTER Unsweetened .webp"
import butterJuggery from "../assets/images/PEANUT BUTTER JAGGERY .webp"
import butterChoclate from "../assets/images/PEANUT BUTTER CHOCOLATE .webp"
import hon1 from "../assets/images/honey1.png";
import csugar from "../assets/images/csugar.png";
import palm from "../assets/images/palm.png";
import brick from "../assets/images/brick.webp";
import salt from "../assets/images/salt.webp";
import almond from "../assets/images/almond.webp";
import bowl from "../assets/images/bowl.webp";

import deep11 from "../assets/images/deep11.png";

// import dee from "../assets/images/dee.png";
import coco from "../assets/images/co1.webp";


const products = [
  {
    id: 1,
    name: "Haronics Coconut Oil",
    imageFront: coco,
    rating: 4.5,
    category: "oil",
    sizes: [
      { size: "500 ML", price: 300 },
      { size: "1 Liter", price: 600 },
      { size: "5 Liter", price: 3000 }
    ]
  },
  {
    id: 2,
    name: "Haronics Groundnut Oil",
    imageFront: product2,
    rating: 4.8,
    category: "oil",
    sizes: [
      { size: "500 ML", price: 200 },
      { size: "1 Liter", price: 360 },
      { size: "5 Liter", price: 1700 }
    ]
  },
  {
    id: 3,
    name: "Haronics Sesame Oil",
    imageFront: product3,
    rating: 4.8,
    category: "oil",
    sizes: [
      { size: "500 ML", price: 250 },
      { size: "1 Liter", price: 500 },
      { size: "5 Liter", price: 2400 }
    ]
  },
  {
    id: 4,
    name: "Haronics Musturd Oil",
    imageFront: product4,
    rating: 4.8,
    category: "oil",
    sizes: [
      { size: "500 ML", price: 250 },
      { size: "1 Liter", price: 450 },
      { size: "5 Liter", price: 2200 }
    ]
  },

  {
    id: 5,
    name: "Haronics Castor Oil",
    imageFront: product6,
    rating: 4.8,
    category: "oil",
    sizes: [
      { size: "500 ML", price: 200 },
      { size: "1 Liter", price: 400 }
    ]
  },
  {
    id: 6,
    name: "Haronics Deepum Oil",
    imageFront: product5,
    rating: 4.7,
    category: "oil",
    sizes: [
      { size: "500 ML", price: 150 },
      { size: "1 Liter", price: 250 }
    ]
  },
  {
    id: 7,
    name: "Haronics Coconut Chips-Chocolate",
    imageFront: chips2,
    rating: 4.8,
    category: "chips",
    sizes: [
      { size: "1 Pack", price: 50 },
    ]
  },
  {
    id: 8,

    name: "Haronics Coconut Chips-Original",
    imageFront: chips3,
    rating: 4.7,
    category: "chips",
    sizes: [
      { size: "1 Pack", price: 50 },
    ]
  },
  {
    id: 9,
    name: "Haronics Coconut Chips-Vanilla",
    imageFront: chips4,
    rating: 4.8,
    category: "chips",
    sizes: [
      { size: "3 Packs", price: 50 },
    ]
  },
  {
    id: 10,
    name: "Haronics Coconut Chips-Rose",
    imageFront: rose,
    rating: 4.8,
    category: "chips",
    sizes: [
      { size: "3 Packs", price: 50 },
    ]
  },
  {
    id: 11,
    name: "Haronics Chips - Rose, Vanilla AND Original Chips",
    imageFront: chips5,
    rating: 4.8,
    category: "chips",
    sizes: [
      { size: "3 Packs", price: 150 },
      // { size: "1 Packs", price: 9.49 },
    ]
  },


  {
    id: 12,
    name: "Haronics Peanut Butter – Unsweetened",
    imageFront: butterunsweet,
    rating: 4.8,
    category: "butter",
    sizes: [
      { size: "300gm ", price: 280 },
    ]
  },
  {
    id: 13,
    name: "Haronics Peanut Butter – Jaggery Sweetened",
    imageFront: butterJuggery,
    rating: 4.8,
    category: "butter",
    sizes: [
      { size: "300 gm", price: 300 },

    ]
  },
  {
    id: 14,
    name: "Haronics Peanut Butter – Chocolate",
    imageFront: butterChoclate,
    rating: 4.8,
    category: "butter",
    sizes: [
      { size: "300 gm", price: 320 },
    ]
  },
  {
    id: 15,
    name: "Haronics A2 Gir Cow Bilona Ghee",
    imageFront: ghee1,
    rating: 4.8,
    category: "ghee",
    sizes: [
      { size: "200 ML", price: 550 },
      { size: "500 ML", price: 1350 },
      { size: "1 Liter", price: 2600 },
    ]
  },
  {
    id: 17,
    name: "Haronics Farm Honey",
    imageFront: hon1,
    rating: 4.8,
    category: "honey",
    sizes: [
      { size: "500 gm", price: 550 },
      { size: "1 Kg", price: 1000 },
    ]
  },
  {
    id: 23,
    name: "Haronics Almond Oil",
    imageFront: almond,
    rating: 4.8,
    category: "oil",
    sizes: [
      { size: "250 ML", price: 1200 },
      { size: "500 ML", price: 2000 },
      { size: "1 Litre", price: 4000 },
    ]
  },
  {
    id: 16,
    name: "Haronics Cane Jaggery Powder",
    imageFront: juggery,
    rating: 4.8,
    category: "juggery",
    sizes: [
      { size: "500 gm", price: 80 },
      { size: "1 Kg", price: 150 },
    ]
  },

  {
    id: 18,
    name: "Haronics Coconut Sugar",
    imageFront: csugar,
    rating: 4.8,
    category: "sugar",
    sizes: [
      { size: "250 gm", price: 150 },
      { size: "500 gm", price: 300 },
      { size: "1 Kg", price: 550 },
    ]
  },
  {
    id: 19,
    name: "Haronics Palm  Sugar",
    imageFront: palm,
    rating: 4.8,
    category: "sugar",
    sizes: [
      { size: "250 gm", price: 150 },
      { size: "500 gm", price: 300 },
      { size: "1 Kg", price: 550 },
    ]
  },
  {
    id: 22,
    name: "Haronics Himalayan Pink Salt",
    imageFront: salt,
    rating: 4.8,
    category: "salt",
    sizes: [
      { size: "500 gm", price: 100 },
      { size: "1 Kg", price: 200 },
      // { size: "500 gm", price: 300 },
    ]
  },
  {
    id: 21,
    name: "Haronics Coco Peat Brick",
    imageFront: brick,
    rating: 4.8,
    category: "others",
    sizes: [
      { size: "5 Kg", price: 300 },
      // { size: "500 gm", price: 300 },
    ]
  },
  {
    id: 20,
    name: "Haronics Coconut Bowls",
    imageFront: bowl,
    rating: 4.8,
    category: "others",
    sizes: [
      { size: "Small", price: 250 },
      { size: "Big", price: 300 },
    ]
  },
];

const ProductCard = ({ product }) => {
  const [selectedSize, setSelectedSize] = useState(product.sizes[0].size);
  const defaultSize = product.sizes.find(size => size.size === selectedSize);

  const handleSizeSelect = (size) => {
    setSelectedSize(size);
  };

  return (
    <>

      <div className="col-md-6 col-lg-4" id="products-section" data-category={product.category}>
        <div className="product-card">
          <div className="product-img-container">
            <Link to={`/product/${product.id}`}>
              <img src={product.imageFront} alt={`${product.name} Front`} className="product-img product-img-front" />
            </Link>
          </div>
          <div className="card-body p-3">
            <h4 className="card-title">{product.name}</h4>
            <div className="google-rating">
              <div className="google-stars">
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star-half-alt"></i>
              </div>
            </div>
            <div className="size-selector row " data-product-id={product.id}>
              <div className="product-price col-6" id={`price-${product.id}`}>
                ₹ {defaultSize.price.toFixed(2)}
              </div>

              <div className='col-6 selectSizeConatiner'>
                {product.sizes && product.sizes.length > 1 && ( // Changed condition to > 1
                  <select
                    className="form-select w-100 mt-2"
                    aria-label="Select size"
                    value={selectedSize}
                    onChange={(e) => handleSizeSelect(e.target.value)}
                  >
                    {product.sizes.map((sizeObj, index) => (
                      <option key={index} value={sizeObj.size}>
                        {sizeObj.size}
                      </option>
                    ))}
                  </select>
                )}
              </div>
            </div>

            <div>
              <Link className="buy-btn" to={`/product/${product.id}`}>Buy Now</Link>
            </div>
          </div>
        </div>
      </div>

    </>

  );
};

const ProductFilter = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [filteredProducts, setFilteredProducts] = useState(products);

  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollToId) {
      const el = document.getElementById(location.state.scrollToId);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  useEffect(() => {
    const filtered = selectedCategory === 'all'
      ? products
      : products.filter(product => product.category === selectedCategory);
    setFilteredProducts(filtered);
  }, [selectedCategory]);

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
  };

  return (
    <div className="productsContainerHaro" id='productFilter'>
      <h2 className='titleProd'>Explore Our Products</h2>
      <div className="d-flex justify-content-between align-items-center product-filter-container mb-4">
        <h2 className="section-heading">Our Products</h2>
        <div className='formSelectProHaro'>
          <select
            className="form-select"
            style={{ width: '200px' }}
            onChange={handleCategoryChange}
            value={selectedCategory}
          >
            <option value="all">All </option>
            <option value="oil">Oil</option>
            <option value="ghee">Ghee</option>
            <option value="butter">Peanut Butter</option>
            <option value="juggery">Jaggery</option>
            <option value="honey">Honey </option>
            <option value="sugar">Sweeteners</option>
            <option value="salt">Salts</option>
            <option value="chips">Chips </option>
            <option value="others">Others </option>
          </select>
        </div>

      </div>
      <div className="row g-4" id="productsContainer">
        {filteredProducts.map(product => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </div>
  );
};

export default ProductFilter;
